module.exports = "<router-outlet></router-outlet>\n\n<simple-notifications [options]=\"notif_options\"></simple-notifications>\n"